import moment from 'moment'
import router from '@/router'
import { apiResource } from '@/util/resources'

export default {
  state: {
    authenticated: false,
    access_token: null,
    token_expires: null,
    refreshing: false,
    auth_type: null,
    socSecVerified: false,
    paymentRedirectUrl: null,
    paymentDebtNr: null,
    paymentType: '',
    privacyConsentAnswered: false,
    cookiesAllowed: false,
    trackingAllowed: false,
    showSurvey: true,
    missingContactInformationQueried: null,
    showVerdictDialogQueried: false,
    verdictData: {
      Email: '',
      OrderNrs: '',
      Lang: '',
      AuthMode: ''
    },
    locale: 'fi',
    signicatAuthenticated: false,
    authenticating: false
  },
  mutations: {
    authenticateUser (state, token) {
      state.access_token = token.access_token
      state.token_expires = token.token_expires
      state.authenticated = true
      state.auth_type = token.auth_type

      window._paq.push(['trackEvent', 'Login', 'Session start', 'Session start', token.auth_type])
    },
    setToken (state, token) {
      state.access_token = token.access_token
      state.token_expires = token.token_expires
      apiResource.defaults.headers.common['Authorization'] = 'Bearer ' + token.access_token
    },
    setRefreshing (state, payload) {
      state.refreshing = payload
    },
    setSocSecVerified (state, payload) {
      state.socSecVerified = payload
    },
    setPaymentRedirectUrl (state, payload) {
      state.paymentRedirectUrl = payload
    },
    setPaymentType (state, payload) {
      state.paymentType = payload
    },
    setPaymentDebtNr (state, payload) {
      state.paymentDebtNr = payload
    },
    logoutUser (state) {
      state.authenticated = false
      state.access_token = null
      state.token_expires = null
      state.auth_type = null
      state.socSecVerified = false
      state.paymentRedirectUrl = null
      state.showVerdictDialogQueried = false
      state.authenticating = false
      delete apiResource.defaults.headers.common['Authorization']
    },
    setLocale (state, payload) {
      state.locale = payload
    },
    trackingAllowed (state, payload) {
      state.trackingAllowed = payload
      state.privacyConsentAnswered = true
    },
    cookiesAllowed (state, payload) {
      state.cookiesAllowed = payload
      state.privacyConsentAnswered = true
    },
    privacyConsentAnswered (state, payload) {
      state.privacyConsentAnswered = payload
    },
    setShowSurvey (state, payload) {
      state.showSurvey = payload
    },
    setMissingContactInformationQueried(state, payload) {
      state.missingContactInformationQueried = payload
    },
    setVerdictData (state, payload) {
      state.verdictData = payload
    },
    setShowVerdictDialogQueried (state, payload) {
      state.showVerdictDialogQueried = payload
    },
    setsignicatAuthenticated(state, value) {
      state.signicatAuthenticated = value
    },
    setAuthenticating (state, payload) {
      state.authenticating = payload
    }
  },
  actions: {
    initialize ({ state, commit, dispatch }, payload) {
      if (!state.initializing) {
        commit('setInitializing', true)
        commit('clearError')

        apiResource.defaults.headers.common['Authorization'] = 'Bearer ' + state.access_token

        apiResource.get('api/debtor').then((response) => {
          commit('setInitializing', false)
          if (response.data.status === 0) {
            var data = response.data.responseObject
            commit('setDebtor', data.debtor)
            commit('setDebts', data.debts)
            commit('setPayments', data.debts)
            commit('setPaymentPlans', data.paymentPlans)
            commit('setSummary', data.summary)
            commit('setBankAccount', data.bankAccounts)
            commit('setHidePersonalInfo', data.debts)
            commit('setHasJPVActiveDebtorNr', data.debtor)
            commit('setReconciliation', data.reconciliation)
            dispatch('refreshPendingPayment')
            // dispatch('showAvailableVerdictMessage')

            if (payload !== undefined && payload !== null) {
              if (payload.hasOwnProperty('redirectTo') && payload.redirectTo !== null) {
                router.push(payload.redirectTo)
              } else if (payload.hasOwnProperty('redirectToLatestPaymentPlan') && payload.redirectToLatestPaymentPlan && data.paymentPlans.length) {
                let latestPaymentPlan = data.paymentPlans.sort(function (a, b) { return b.nr - a.nr }).slice(0, 1)
                if (latestPaymentPlan !== null && latestPaymentPlan.length === 1) {
                  router.push('/payment-plan/' + latestPaymentPlan[0].debts[0].nr)
                }
              }

              if (payload.hasOwnProperty('type') && payload.type === 'paymentplan') {
                commit('setShowPaymentPlanCreatedDialog', true)
              }
            }
          } else {
            commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true })
          }
        }).catch((errorResponse) => {
          console.log('initialize error', errorResponse)
          commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          commit('setInitializing', false)
        })
      }
    },
    silentInitialize ({ state, commit }, payload) {
      if (!state.initializing) {
        commit('clearError')

        apiResource.get('api/debtor').then((response) => {
          if (response.data.status === 0) {
            var data = response.data.responseObject
            commit('setDebtor', data.debtor)
            commit('setDebts', data.debts)
            commit('setPayments', data.debts)
            commit('setPaymentPlans', data.paymentPlans)
            commit('setSummary', data.summary)
            commit('setHidePersonalInfo', data.debts)
            commit('setReconciliation', data.reconciliation)
            commit('setBankAccount', data.bankAccounts)

            if (payload.type === 'reconciliation') {
              commit('setShowReconciliationCompleteDialog', true)
            }

            commit('setLoading', false)
          }
        }).catch((errorResponse) => {
          commit('setLoading', false)
          // commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        })
      }
    },
    refreshPendingPayment ({ commit }) {
      commit('clearError')
      apiResource.get('api/payments/pending').then((response) => {
        if (response.data.status === 0) {
          commit('setPaymentPending', response.data.responseObject)
        } else {
          commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true })
        }
      }).catch((errorResponse) => {
        commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
      })
    },
    logout ({ commit }) {
      commit('logoutUser')
      commit('logoutDebts')
      commit('logoutDebtor')
      commit('logoutReconciliation')
      commit('logoutCart')

      commit('setLoading', false)
      commit('setInitializing', false)
      commit('clearError')
      commit('setsignicatAuthenticated', false)

      delete apiResource.defaults.headers.common['Authorization']

      router.push('/')
    },
    getAuthenticationUrl ({ commit }, userData) {
      commit('setLoading', true)
      commit('clearError')
      apiResource.post('api/authentication/url', userData).then((response) => {
        commit('setLoading', false)
        window.location.href = response.data
      }).catch((errorResponse) => {
        commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        commit('setLoading', false)
      })
    },
    getAuthenticationUrlForLogin ({ commit }) {
      commit('setLoading', true)
      commit('clearError')
      apiResource.post('api/authentication/urlLogin').then((response) => {
        commit('setLoading', false)
        window.location.href = response.data
      }).catch((errorResponse) => {
        commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        commit('setLoading', false)
      })
    },
    authenticateUser ({ state, commit, dispatch }, userData) {
      if (state.authenticating) {
        return
      }
      commit('setAuthenticating', true)
      commit('setLoading', true)
      commit('clearError')
      apiResource.post('api/login', userData).then((response) => {
        commit('setLoading', false)
        if (response.data.Status === 0) {
          let tokenExpires = moment().add(response.data.expires_in, 'seconds')
          commit('authenticateUser', { access_token: response.data.access_token, token_expires: tokenExpires, auth_type: userData.LoginType })
          let payload = {}
          if (userData.hasOwnProperty('redirectTo') && userData.redirectTo !== null) {
            payload.redirectTo = userData.redirectTo
          }
          dispatch('initialize', payload)
        } else {
          commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true })
          commit('setAuthenticating', false)
        }
      }).catch((errorResponse) => {
        console.log('authenticateUser error', errorResponse)
        commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
        commit('setLoading', false)
        commit('setAuthenticating', false)
      })
    },
    refreshUserToken ({ state, commit }) {
      return new Promise((resolve, reject) => {
        if (moment() > moment(state.token_expires)) {
          commit('setRefreshing', false)
          return reject()
        } else if (moment().add(25, 'minutes') <= moment(state.token_expires) || state.refreshing) {
          return resolve()
        }

        commit('setRefreshing', true)
        apiResource.defaults.headers.common['Authorization'] = 'Bearer ' + state.access_token

        apiResource.post('api/refresh', {}).then((response) => {
          let tokenExpires = moment().add(response.data.expires_in, 'seconds')
          commit('setToken', { access_token: response.data.access_token, token_expires: tokenExpires })
          commit('setRefreshing', false)
          resolve(response)  // Let the calling function know that http is done. You may send some data back
        }, error => {
          commit('setError', error)
          commit('setRefreshing', false)
          reject(error)
        })
      })
    },
    authenticateSocSecNr ({ commit, dispatch }, userData) {
      return new Promise((resolve, reject) => {
        commit('setLoading', true)
        commit('clearError')
        apiResource.post('api/login', userData).then((response) => {
          commit('setLoading', false)
          if (response.data.Status === 0) {
            let tokenExpires = moment().add(response.data.expires_in, 'seconds')
            commit('authenticateUser', { access_token: response.data.access_token, token_expires: tokenExpires, auth_type: userData.LoginType })
            commit('setSocSecVerified', true)
            dispatch('initialize')
          } else {
            // commit('setMessage', { type: 'error', text: response.data.ErrorCode, translate: true })
            commit('setMessage', { type: 'error', text: 'errorTextPrivate', translate: true })
          }
          return resolve()
        }).catch((errorResponse) => {
          commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
          commit('setLoading', false)
          return reject(errorResponse)
        })
      })
    },
    autoLogin ({ state, dispatch }) {
      if (state.access_token != null && state.token_expires != null) {
        if (moment().isSameOrAfter(moment(state.token_expires))) {
          dispatch('logout')
        } else {
          dispatch('initialize')
        }
      }
    }
  },
  getters: {
    authenticated (state) {
      return state.authenticated
    },
    access_token (state) {
      return state.access_token
    },
    token_expires (state) {
      return state.token_expires
    },
    auth_type (state) {
      return state.auth_type
    },
    socSecVerified (state) {
      return state.socSecVerified
    },
    locale (state) {
      return state.locale
    },
    longLocale (state) {
      if (state.locale === 'fi') {
        return 'fi-FI'
      } else if (state.locale === 'se') {
        return 'sv-SE'
      } else if (state.locale === 'en') {
        return 'en-US'
      } else {
        return 'fi-FI'
      }
    },
    paymentRedirectUrl (state) {
      return state.paymentRedirectUrl
    },
    paymentType (state) {
      return state.paymentType
    },
    paymentDebtNr (state) {
      return state.paymentDebtNr
    },
    trackingAllowed (state) {
      return state.trackingAllowed
    },
    cookiesAllowed (state) {
      return state.cookiesAllowed
    },
    privacyConsentAnswered (state) {
      return state.privacyConsentAnswered
    },
    showSurvey (state) {
      return state.showSurvey
    },
    missingContactInformationQueried (state) {
      return state.missingContactInformationQueried
    },
    verdictData (state) {
      return state.verdictData
    },
    showVerdictDialogQueried (state) {
      return state.showVerdictDialogQueried
    },
    signicatAuthenticated(state) {
      return state.signicatAuthenticated
    },
    authenticating (state) {
      return state.authenticating
    }
  }
}
